import { Button, InputAdornment, TextField, Icon, Grid, FormControlLabel, Switch, IconButton, CircularProgress } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import CustomMaskedInput from 'components/MaskedInput/index';
import { clearMoneyMask } from 'helpers/functions';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { loadCustomerByEmail } from 'store/Orbita/Customer/actions';
import { ruleRunner, run } from 'validations/ruleRunner';
import { required, isEmail } from 'validations/rules';

import type { DispatchProp } from 'react-redux';

const styles = withStyles(() => ({
  freeCoAffiliates: {
    backgroundColor: '#E8E8E8',
    borderRadius: '4px 4px 0 0',
    padding: '0.5rem',
  },
  freeCoAffiliateField: {
    backgroundColor: '#E8E8E8',
    borderRadius: '0 4px 4px 4px',
    padding: '0.5rem',
  },
  customItem: {
    padding: '0.5rem',
  },
  icon: {
    marginTop: '1.5rem',
  },
}));

const Validations = [ruleRunner('email', 'e-mail do co-afiliado', required, isEmail)];

interface IProps extends DispatchProp<any>, StyledComponentProps {
  coaffiliates: any;
  onChangeCheck: any;
  setReadyToSave: any;
  customer: any;
  handleChangeCoAffiliates: any;
  public: any;
}

class Coaffiliates extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      coaffiliates: JSON.parse(JSON.stringify(this.props.coaffiliates)),
      showErrors: false,
      validationErrors: {},
      canDelete: true,
      isSearching: false,
    };
  }

  onChangeEmail = (e: any, index: any) => {
    const newCoaffiliates = this.state.coaffiliates;
    newCoaffiliates[index].email = e.target.value;
    let validationErrors = this.state.validationErrors;
    validationErrors = run({ email: e.target.value }, Validations);

    this.setState({ coaffiliates: newCoaffiliates, validationErrors });
    this.props.setReadyToSave(false);
    this.setState({ canDelete: false });
  };

  onChangePercent = (value: any, index: any) => {
    const newCoaffiliates = this.state.coaffiliates;
    newCoaffiliates[index].percent = clearMoneyMask(value);

    this.props.handleChangeCoAffiliates(newCoaffiliates);

    this.setState({ coaffiliates: newCoaffiliates });
  };

  onSearchCustomerByEmail = (email: any, index: any) => {
    (async () => {
      this.setState({ isSearching: true });
      await this.props.dispatch(loadCustomerByEmail(email));
      const customer = this.props.customer?.length > 0 ? this.props.customer[0] : null;
      this.setState({ canDelete: true, isSearching: false });
      if (!customer) {
        toast.error('Insira um email válido!');
      } else {
        const newCoaffiliates = this.state.coaffiliates;
        if (newCoaffiliates[index]) {
          newCoaffiliates[index].name = customer.name;
          newCoaffiliates[index].customer_id = customer.id;
          newCoaffiliates[index].disabled = Number(localStorage.getItem('id')) === customer.id;
          this.props.handleChangeCoAffiliates(newCoaffiliates);
          this.setState({ coaffiliates: newCoaffiliates });
          this.props.setReadyToSave(true);
        }
      }
    })();
  };

  deleteCoaffiliate = (k: any) => {
    const newCoaffiliates = this.state.coaffiliates;
    const filtered = newCoaffiliates.filter((value: any, index: any) => {
      return index !== k;
    });
    this.props.handleChangeCoAffiliates(filtered);
    this.setState({ coaffiliates: filtered });
    this.props.setReadyToSave(true);
  };

  handleChangePublic = (e: any) => {
    const newCoaffiliates = this.state.coaffiliates;
    let filtered = [];
    if (e.target.checked) {
      newCoaffiliates.unshift({
        customer_id: 123456,
        percent: 0,
        name: 'Parceiros de Divulgação [Co-Afiliado]',
        email: null,
      });
      filtered = newCoaffiliates;
    } else {
      filtered = newCoaffiliates.filter((value: any) => {
        return value.customer_id !== 123456;
      });
    }
    this.props.onChangeCheck('public', e);
    this.props.handleChangeCoAffiliates(filtered);
    this.setState({ coaffiliates: filtered });
  };

  addNewEmpty = () => {
    const newCoaffiliates = this.state.coaffiliates;
    newCoaffiliates.push({
      customer_id: 0,
      percent: 0,
      name: 'Busque seu co-afiliado',
      email: '',
    });
    this.props.handleChangeCoAffiliates(newCoaffiliates);
    this.setState({ coaffiliates: newCoaffiliates });
  };

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  render() {
    const { classes } = this.props;
    const coaffiliatesList = this.state.coaffiliates.map((item: any, index: any) => {
      if (item.customer_id === 123456) {
        return (
          <Grid container key={'coafi' + index} alignItems='center' className={classes.freeCoAffiliateField}>
            <Grid item xs={10}>
              <label>{item.name}</label>
            </Grid>
            <Grid item xs={2}>
              <CustomMaskedInput
                mask='percent'
                label='Porcentagem'
                startAdornment='%'
                fullWidth
                disableUnderline={true}
                value={item.percent}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(value: any) => this.onChangePercent(value, index)}
              />
            </Grid>
          </Grid>
        );
      } else if (Number(localStorage.getItem('id')) === item.customer_id && !item?.disabled) {
        return (
          <Grid container key={'coafi' + index} alignItems='center' spacing={2} className={classes.customItem}>
            <Grid item xs={4}>
              <TextField
                disabled
                id='email'
                label='E-mail do co-afiliado'
                fullWidth
                value={item.email}
                InputProps={{
                  disableUnderline: true,
                  endAdornment: (
                    <InputAdornment position='end'>
                      <Button size='small' disabled>
                        <Icon>search</Icon>
                      </Button>
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id='name'
                label='Nome do co-afiliado'
                fullWidth
                disabled={true}
                value={item.name}
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <CustomMaskedInput
                mask='percent'
                label='Porcentagem'
                startAdornment='%'
                fullWidth
                disableUnderline={true}
                value={item.percent}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(value: any) => this.onChangePercent(value, index)}
              />
            </Grid>
          </Grid>
        );
      } else {
        return (
          <Grid container key={'coafi' + index} alignItems='center' spacing={2} className={classes.customItem}>
            <Grid item xs={4}>
              <TextField
                id='email'
                disabled={this.state.isSearching}
                label='E-mail do co-afiliado'
                fullWidth
                value={item.email}
                onBlur={() => this.onSearchCustomerByEmail(item.email, index)}
                InputProps={{
                  disableUnderline: true,
                  endAdornment: (
                    <InputAdornment position='end'>
                      {this.state.isSearching ? (
                        <CircularProgress className={classes.progress} size={20} />
                      ) : (
                        <Button
                          size='small'
                          disabled={this.isValid('email') || !item.email}
                          onClick={() => this.onSearchCustomerByEmail(item.email, index)}
                        >
                          <Icon>search</Icon>
                        </Button>
                      )}
                    </InputAdornment>
                  ),
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e: any) => this.onChangeEmail(e, index)}
                helperText={this.isValid('email') ? this.errorFor('email') : null}
                error={this.isValid('email')}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                id='name'
                label='Nome do co-afiliado'
                fullWidth
                disabled={true}
                value={item.name}
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <CustomMaskedInput
                mask='percent'
                label='Porcentagem'
                startAdornment='%'
                fullWidth
                disableUnderline={true}
                value={item.percent}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(value: any) => this.onChangePercent(value, index)}
              />
            </Grid>
            <IconButton disabled={!this.state.canDelete} color='primary' className={classes.icon} onClick={() => this.deleteCoaffiliate(index)}>
              <Icon>delete</Icon>
            </IconButton>
          </Grid>
        );
      }
    });

    return (
      <Fragment>
        <Grid container justify='space-between'>
          <Grid item className={this.props.public && classes.freeCoAffiliates}>
            <FormControlLabel
              label='Essa campanha é pública?'
              control={<Switch color='primary' checked={this.props.public} onChange={(e: any) => this.handleChangePublic(e)} />}
            />
          </Grid>
          <Grid item className={classes.customItem}>
            {this.state.coaffiliates.filter((item: any) => item.customer_id !== 123456 && Number(localStorage.getItem('id')) !== item.customer_id)
              .length === 0 && (
              <Button color='secondary' variant='contained' onClick={this.addNewEmpty}>
                Novo
              </Button>
            )}
          </Grid>
        </Grid>
        {coaffiliatesList}
      </Fragment>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    customer: state.orbita.Customer.byEmail.data,
  };
}

export default connect(mapStateToProps)(styles(Coaffiliates));
